import { PartialCheckbox } from '../PartialCheckbox';
import styles from './PartialLabelCheckbox.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PartialLabelCheckbox = function PartialLabelCheckbox(props) {
  var value = props.value,
      label = props.label;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['partial-checkbox-wrapper'],
      children: /*#__PURE__*/_jsx(PartialCheckbox, {
        value: value
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles['label'],
      children: label
    })]
  });
};